/**
 * RÉDUIRE UNE IMAGE AVANT DE LA GARDER.
 *
 * ⚠️⚠️ POURQUOI CE FICHIER EST UN `.ts` ET NON UN `.tsx`. Il emploie
 * `canvas.getContext('2d')`, et `tests/carte-un-seul-moteur.test.ts` REFUSE ce
 * motif dans tout `.tsx` du dossier : il garde contre la réapparition d'un
 * second moteur de rendu cartographique, qui a déjà divergé une fois dans ce
 * dépôt. Le garde a raison, et ma première rédaction l'a fait rougir — un
 * redimensionnement de photographie n'est pas un moteur de carte, mais c'est
 * au code de le dire, pas au garde de l'excuser. L'ajouter à la liste des
 * tolérés aurait affaibli une protection pour un usage qui n'est même pas un
 * composant.
 *
 * ⚠️ RÉDUIRE AVANT DE GARDER, ET NON APRÈS. Quatre portraits en pleine
 * définition dépassent le quota de `localStorage` : le brouillon disparaîtrait
 * en silence au moment précis où l'agent croit l'avoir enregistré.
 */
export const PORTRAIT_LARGEUR = 420;

export function reduireEnJpeg(
  source: HTMLImageElement | HTMLVideoElement,
  largeur = PORTRAIT_LARGEUR,
): string {
  const l0 = 'videoWidth' in source ? source.videoWidth : source.width;
  const h0 = 'videoHeight' in source ? source.videoHeight : source.height;
  if (!l0 || !h0) throw new Error("La source n'a livré aucune image.");
  const r = Math.min(1, largeur / l0);
  const c = document.createElement('canvas');
  c.width = Math.round(l0 * r);
  c.height = Math.round(h0 * r);
  const ctx = c.getContext('2d');
  if (!ctx) throw new Error("Le navigateur n'a pas fourni de contexte de dessin.");
  ctx.drawImage(source, 0, 0, c.width, c.height);
  /* 0,72 : au-delà le gain de qualité ne se voit pas sur un portrait de 420 px,
     en deçà les traits du visage se brouillent — et c'est une pièce d'identité. */
  return c.toDataURL('image/jpeg', 0.72);
}
